import React, { useState, useContext } from 'react';
import ProfileDP from '../components/ProfileDP';
import Button from '../components/Button';
import { ThemeContext } from '../theme';

// Figma assets — valid ~7 days from generation
const ILLUS_URL   = 'https://res.cloudinary.com/dcnujnpbm/image/upload/q_auto/f_auto/v1776961699/onboarding_image_4_c2vqvj.webp';
const EDA_URL     = 'https://res.cloudinary.com/dcnujnpbm/image/upload/q_auto/f_auto/v1776961468/eda_dp_fszpol.webp';
const KIRAZ_URL   = 'https://res.cloudinary.com/dcnujnpbm/image/upload/q_auto/f_auto/v1776961469/kiraz_dp_gs0phi.webp';

const SCALE = 0.75;
const s = (n) => Math.round(n * SCALE);

const PROFILES = [
  { id: 'eda',   variant: 'adult', src: EDA_URL,   name: 'Eda' },
  { id: 'kiraz', variant: 'kid',   src: KIRAZ_URL, name: 'Kiraz' },
];

export default function SelectProfileScreen({ onBack, onNext }) {
  const theme = useContext(ThemeContext);
  const [selected, setSelected] = useState('kiraz');

  return (
    <div style={{ flex: 1, alignSelf: 'stretch', display: 'flex', backgroundColor: theme.bgPrimary }}>
      <style>{`
        @keyframes onboardImgScaleOut {
          from { transform: scale(1.2); }
          to   { transform: scale(1); }
        }
      `}</style>

      {/* Left panel — warm peach illustration */}
      <div style={{ width: '38%', flexShrink: 0, position: 'relative', overflow: 'hidden', backgroundColor: '#fcf1e8' }}>
        <img
          src={ILLUS_URL}
          alt=""
          style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center top', animation: 'onboardImgScaleOut 0.6s ease-out both' }}
        />
      </div>

      {/* Right panel */}
      <div
        style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '24px 104px',
          overflowY: 'auto',
          backgroundColor: theme.cardBg,
        }}
      >
        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: s(80) }}>

          {/* Header */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: s(8) }}>
            <h1
              className="font-bogart"
              style={{ fontSize: s(36), fontWeight: 700, lineHeight: `${s(44)}px`, color: theme.text100, margin: 0 }}
            >
              Select a profile<br />to proceed
            </h1>
            <p
              className="font-satoshi"
              style={{ margin: 0, fontSize: s(18), lineHeight: `${s(28)}px`, color: theme.text400, fontWeight: 400 }}
            >
              Select profile for a tailored storytelling experience
            </p>
          </div>

          {/* Profile DPs */}
          <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center' }}>
            {PROFILES.map(p => (
              <ProfileDP
                key={p.id}
                variant={p.variant}
                src={p.src}
                name={p.name}
                selected={selected === p.id}
                onClick={() => setSelected(p.id)}
                scale={SCALE}
              />
            ))}
            <ProfileDP
              variant="add"
              name="Kids Profile"
              selected={selected === 'add'}
              onClick={() => setSelected('add')}
              scale={SCALE}
            />
          </div>

          {/* Back + Next buttons */}
          <div style={{ display: 'flex', gap: s(20) }}>
            <Button variant="tertiary" onClick={onBack} scale={SCALE} style={{ flex: 1 }}>
              Back
            </Button>
            <Button variant="primary" onClick={() => onNext(selected)} scale={SCALE} style={{ flex: 1 }}>
              Next
            </Button>
          </div>

        </div>
      </div>

    </div>
  );
}
